<template>
   <CardUploadFiles
      :isVisiblePrimary="false"
      :titleCard="'Precisamos verificar seu CRLV'"
      :cardDescription="'crlv'"
      :textCard="'CRLV'"
      :textCardAttention="'O documento precisa estar no nome do titular'"
      :srcExampleImage="IconDocument"
      :nextRoute="'UploadRenavam'"
      :previewScreen="'PreviewDocumentationFiles'"
   />
</template>
<script>
import CardUploadFiles from '../../components/CardUploadFiles.vue'
import FooterButton from '../../components/FooterButton.vue';
import IconDocument from '../../../../public/images/illustration-document.svg'

export default {
components: {
   CardUploadFiles,
   FooterButton
},
setup() {
   return {
       IconDocument
   };
 },
}
</script>